export type AuthEvent =
  | { type: "logout"; reason?: string }
  | { type: "tokensUpdated"; accessToken: string; refreshToken: string };

type AuthEventListener = (event: AuthEvent) => void;

const listeners = new Set<AuthEventListener>();

export const subscribeAuthEvents = (listener: AuthEventListener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const emitAuthLogout = (reason?: string) => {
  listeners.forEach((listener) => listener({ type: "logout", reason }));
};

export const emitTokensUpdated = (accessToken: string, refreshToken: string) => {
  listeners.forEach((listener) => listener({ type: "tokensUpdated", accessToken, refreshToken }));
};
